var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", null, ".flyer-cover_svg__st3{fill:#260046}.flyer-cover_svg__st5{fill:#ea4403}");

var _ref3 = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 40,
  r: 40,
  fill: "none"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "flyer-cover_svg__SVGID_1_",
  d: "M0 0h80v80H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "flyer-cover_svg__SVGID_00000043431031453273141030000007923507478830660777_"
}, /*#__PURE__*/React.createElement("use", {
  overflow: "visible",
  xlinkHref: "#flyer-cover_svg__SVGID_1_"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#flyer-cover_svg__SVGID_00000043431031453273141030000007923507478830660777_)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#eaeaea",
  d: "M40 80c22.093 0 40-17.909 40-40C80 17.907 62.093-.001 40-.001S0 17.907 0 40c0 22.092 17.907 40 40 40"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#flyer-cover_svg__SVGID_00000043431031453273141030000007923507478830660777_)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M55.537 57.785c0 1.18-.966 2.146-2.146 2.146h-32.82a2.153 2.153 0 01-2.146-2.146V17.644c0-1.179.967-2.144 2.146-2.144h32.821c1.18 0 2.146.966 2.146 2.144v40.141z",
  className: "flyer-cover_svg__st3"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M61.575 62.354c0 1.18-.966 2.146-2.146 2.146h-32.82a2.153 2.153 0 01-2.146-2.146V22.213c0-1.179.967-2.144 2.146-2.144H59.43c1.18 0 2.146.966 2.146 2.144v40.141z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.491 46.919a2.57 2.57 0 01-2.567-2.566.52.52 0 011.042 0c0 .841.685 1.525 1.525 1.525s1.525-.684 1.525-1.525V31.797a.52.52 0 111.042 0v12.555a2.57 2.57 0 01-2.567 2.567M43.537 27.855a.521.521 0 01-.521-.521v-1.983a.521.521 0 011.043 0v1.983a.522.522 0 01-.522.521",
  className: "flyer-cover_svg__st3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.591 35.874c1.32 0 2.456.719 2.99 1.76.534-1.04 1.67-1.76 2.99-1.76 1.32 0 2.457.719 2.991 1.76.533-1.04 1.67-1.76 2.99-1.76s2.456.719 2.99 1.76c.533-1.04 1.67-1.76 2.99-1.76 1.333 0 2.478.733 3.006 1.788-.029-6.604-5.389-11.583-12.001-11.583-6.63 0-12.004 5.007-12.004 11.636h.026c.514-1.083 1.677-1.841 3.032-1.841",
  className: "flyer-cover_svg__st5"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M29.791 52.956c0-.723.59-1.315 1.315-1.315h23.827c.723 0 1.313.592 1.313 1.315v.839c0 .723-.59 1.315-1.313 1.315H31.106a1.318 1.318 0 01-1.315-1.315v-.839z",
  className: "flyer-cover_svg__st5"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M29.791 59.16c0-.723.59-1.315 1.315-1.315h18.505a1.32 1.32 0 011.315 1.315v.839a1.32 1.32 0 01-1.315 1.315H31.106a1.318 1.318 0 01-1.315-1.315v-.839z",
  className: "flyer-cover_svg__st5"
})))));

var SvgFlyerCover = function SvgFlyerCover(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "flyer-cover_svg__Layer_2",
    x: 0,
    y: 0,
    viewBox: "0 0 80 80",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFlyerCover, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/flyer-cover.dff573f1.svg";
export { ForwardRef as ReactComponent };